'use client';

import React from 'react';
import { useTranslations } from '@royalaholddelhaize/ah-next-core/src/i18n/client';
import { createTestHook } from '@royalaholddelhaize/ah-self-service-toolkit';
import { ChevronRight16Icon } from '@royalaholddelhaize/design-system-pantry-web/assets/icons/ah';
import {
    LinkAnchor,
    LinkText,
} from '@royalaholddelhaize/design-system-pantry-web/components/button/link-button/link-button';
import { Typography } from '@royalaholddelhaize/design-system-pantry-web/foundation/typography/typography';
import css from './no-results.module.scss';

export const NoResults: React.FC<{ query: string }> = ({ query }) => {
    const { t } = useTranslations('zoeken');

    return (
        <div {...createTestHook('no-results')}>
            <Typography className={css.title} variant="heading-3">
                {`${t('noResultsLabel')} "${query}"`}
            </Typography>
            <Typography className={css.subTitle} variant="body-regular">
                {t('noResultsHelp')}
            </Typography>
            <LinkAnchor
                {...createTestHook('search-products-button')}
                className={css.noResultsLink}
                href={`/zoeken?query=${query}`}
            >
                <LinkText>{t('products')}</LinkText>
                <ChevronRight16Icon />
            </LinkAnchor>
            <LinkAnchor
                {...createTestHook('search-recipes-button')}
                className={css.noResultsLink}
                href={`/allerhande/recepten-zoeken?query=${query}`}
            >
                <LinkText>{t('recipes')}</LinkText>
                <ChevronRight16Icon />
            </LinkAnchor>
        </div>
    );
};
